var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203 0C91 0 0 91 0 203s91 203 203 203 203-91 203-203S315 0 203 0zm-60 275c-3 3-8 3-12 0-3-3-3-9 0-12l60-60-60-60c-3-3-3-8 0-12 4-3 9-3 12 0l60 60 60-60c3-3 9-3 12 0 3 4 3 9 0 12l-60 60 60 60c3 3 3 9 0 12s-9 3-12 0l-60-60-60 60z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleFilled);
export default __webpack_public_path__ + "static/media/CloseCircleFilled.ed4543c53a948c932f1ec60a8a2b229d.svg";
export { ForwardRef as ReactComponent };